import axios from "axios";
import httpService from "./http.service";

class OrdersService {
    getOrdersUrl = "/orders/";
    //   ordersAC = "/order/ac";

    getOrders = () => {
        return httpService.get(this.getOrdersUrl);
    };
    getOrder = (id) => {
        return httpService.get(this.getOrdersUrl + id);
    };
    createOrder = (model) => {
        return httpService.post("/orders", model);
    };
    uploadMeasurement = (image) => {
        return httpService.form("/orders/in-person/measurement", { image });
    };
    createInPersonOrder = (model) => {
        return httpService.post("/orders/in-person", model);
    };
    createInPersonPayment = (id, model) => {
        return httpService.post(`/orders/in-person/${id}/payments`, model);
    };
    validatePayment = async (token) => {
        return httpService.get("/orders/verify/" + token);
    };
    editOrder = (id, model) => {
        return httpService.patch("/orders/" + id, model);
    };
    deleteOrder = (id) => {
        return httpService.delete("/orders/" + id);
    };
    getSnappStatus = (id) => {
        return httpService.get(`/orders/${id}/snapp/status`);
    };
    updateSnappOrder = (id, model) => {
        return httpService.post(`/orders/${id}/snapp/update`, model);
    };
    cancelSnappOrder = (id, model) => {
        return httpService.post(`/orders/${id}/snapp/cancel`, model);
    };
    downloadWaranty = async (orderId, orderItemId) => {
        const res = await axios.get(
            `${httpService.getBaseURL()}/orders/downloadtWaranty/${orderId}/${orderItemId}`,
            {
                responseType: 'blob',
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${httpService.getToken()}`,
                    Accept: 'image/jpeg',
                },
            }
        );

        const blob = res.data;

        console.log(blob, blob.size, blob.type);

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `waranty_${orderItemId}.jpg`;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    };

    sendLocation = (model) => {
        return httpService.post("/sms/location", model);
    };
}

const ordersService = new OrdersService();
export default ordersService;
